import { VariantProps, cva } from 'class-variance-authority';

export const notificationCountStyles = cva(
  [
    'rounded-full',
    'inline-flex',
    'items-center',
    'justify-center',
    'min-w-16',
    'min-h-16',
  ],
  {
    variants: {
      intent: {
        default: ['bg-primary100', 'text-primaryMain'],
        new: ['bg-error300', 'text-grayscale0'],
      },
      size: {
        small: ['px-4'], // Default padding
        large: ['px-8'], // Larger padding for counts > 999
      },
    },
    compoundVariants: [
      {
        intent: 'new',
        size: 'large',
      },
    ],
    defaultVariants: {
      size: 'small',
    },
  },
);

export type NotificationCountStyleVariants = VariantProps<
  typeof notificationCountStyles
>;
